// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33zzg","option":"styles_option__2BaX5","active":"styles_active__d0iBB"};